import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IntegrationsService } from 'src/app/domains/integrations/services/integrations.service';
import { AUTHORIZATION_METHOD_TYPE, Integration, IntegrationsFilters } from 'voxloud-types/dist/models/integrations';
import { NotificationService } from '../../services/notification/notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UIIntegration } from 'src/app/domains/integrations/models/integrations.model';
import { EditIntegrationPopupComponent } from 'src/app/features/companies/components/edit-integration-popup/edit-integration-popup.component';
import { IntegrationDetailsPopupComponent } from 'src/app/features/companies/components/integration-details-popup/integration-details-popup.component';
import { concatMap } from 'rxjs/operators';
import { Company } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-integrations-table',
  templateUrl: './integrations-table.component.html',
  styleUrls: ['./integrations-table.component.scss']
})
export class IntegrationsTableComponent {
  @Input() loading: boolean;
  @Input() integrations: Integration[];
  @Input() context: 'global' | 'company';
  @Input() authMethodsType;
  @Input() company?: Company;
  @Output() onUpdateIntegrations: EventEmitter<any> = new EventEmitter();

  filters: IntegrationsFilters;
  public pageSize: number;
  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };
  public AUTH_METHODS = AUTHORIZATION_METHOD_TYPE;
  public isDeleting: boolean;

  constructor(
    private integrationsService: IntegrationsService,
    private notification: NotificationService,
    private modalService: NgbModal,
    private translateService: TranslateService
    ) { }



  enableDisableIntegration(integration: UIIntegration) {
    integration._isLoading = true;
    this.integrationsService.updateIntegration(integration.id,
      {
        name: integration.name,
        enabled: integration.enabled,
        custom_fields: integration.custom_fields
      }
      ).subscribe(
        (res: UIIntegration) => {
        integration._isLoading = false;
        integration = res;
      },
      () => {
        integration.enabled = !integration.enabled;
        integration._isLoading = false;
      }
      )
  }

  onDeleteIntegration(integration: UIIntegration) {
    this.notification.showConfirmation('company.integrations.confirmation.delete').then((result: string) => {
      if(result == 'ok') {
        integration._isLoading = true;
        this.integrationsService.deleteIntegration(integration.id).subscribe(res => {
          this.integrations = this.integrations.filter((el) => el.id !== integration.id);
          integration._isLoading = false;
          this.notification.success('company.integrations.integration-deleted')
        },
        () => {
          integration._isLoading = false;
        })
      }
    })
  }

  openIntegrationDetails(integration: Integration) {
    const modal = this.modalService.open(IntegrationDetailsPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.integration = integration;
  }

  openEditIntegrationPopup(integration: Integration) {
    const modal = this.modalService.open(EditIntegrationPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.integration = integration;
    modal.componentInstance.company = this.company;
    modal.componentInstance.onUpdateIntegration.subscribe(() => {
      this.onUpdateIntegrations.emit();
      this.notification.success('company.integrations.notifications.success.updated');
    })
  }

  onForceContactSync(integration: UIIntegration) {
    this.notification.showConfirmation('company.integrations.confirmation.sync').then((result: string) => {
      if(result == 'ok') {
        integration._isLoading = true;
        this.integrationsService.getPlatformById(integration.platform_id).pipe(concatMap(
          platform => this.integrationsService.forceContactSync(integration.company_id, platform.name)
        )).subscribe(
          () => {
            integration._isLoading = false;
            this.notification.success(this.translateService.instant('company.integrations.notifications.success.synced', {crm: integration.name}));
          },
          () => {
            integration._isLoading = false;
          }
        )

      }
    })
  }

}
